import type { PropsWithChildren } from 'react';
import { useSettings } from '@wu/widget-core';
import { Carousel } from './Carousel';
import { Grid } from './Grid';
import { Slider } from './Slider';

type LayoutProps = PropsWithChildren<{ width: number }>;

export function Layout({ children, width }: LayoutProps) {
  const { layout } = useSettings();

  const LayoutArray = {
    grid: Grid,
    slider: Slider,
    carousel: Carousel
  }[layout];

  return <LayoutArray width={width}>{children}</LayoutArray>;
}
